"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const cw_http_service_1 = require("@dialogexe/cw-http-service");
const actions_1 = require("./actions");
const cw_parameters_provider_1 = require("@dialogexe/cw-parameters-provider");
const getPartnerApi = () => {
    const partners = cw_parameters_provider_1.parametersProvider.get('site.partners');
    switch (partners[0]) {
        case 118:
            return 'api.bryneFilmgrail';
        case 178:
            return 'api.fredrikstadFilmgrail';
    }
};
const getNewPassword = ({ email }) => {
    const baseUrl = getPartnerApi();
    const request = new cw_http_service_1.Request(cw_parameters_provider_1.parametersProvider.get(baseUrl));
    return request.post('forgotPassword', {
        Email: email
    }, null);
};
const loginToFilmgrail = ({ email, password }) => {
    const baseUrl = getPartnerApi();
    const request = new cw_http_service_1.Request(cw_parameters_provider_1.parametersProvider.get(baseUrl));
    return request.post('login', {
        Email: email,
        Password: password,
    }, null, {
        headers: {
            'Content-Type': 'application/json'
        },
    });
};
function* fetchUserProfile(action) {
    try {
        const userInfo = yield effects_1.call(loginToFilmgrail, { email: action.payload.email, password: action.payload.password });
        if (userInfo.data && userInfo.data.marsToken) {
            const profile = { userName: userInfo.data.UserName, email: userInfo.data.UserInfo, token: userInfo.data.marsToken };
            localStorage.setItem("cw-profile-new", JSON.stringify(profile));
            yield effects_1.put(actions_1.actionCreators.putUserProfile(userInfo.data));
        }
    }
    catch (error) {
        yield effects_1.put(actions_1.actionCreators.putLoginFailed(error.response));
    }
}
function* createUser(action) {
    try {
        const userInfo = yield effects_1.call(getProfile, { email: action.payload.email, password: action.payload.password, userName: action.payload.userName });
        if (userInfo.data && userInfo.data.Token) {
            const profile = { userName: userInfo.data.UserName, email: userInfo.data.ContactEmail, token: userInfo.data.Token };
            localStorage.setItem("cw-profile-new", JSON.stringify(profile));
            yield effects_1.put(actions_1.actionCreators.putUserProfile(userInfo.data));
        }
    }
    catch (error) {
        yield effects_1.put(actions_1.actionCreators.putCreateUserFailed(error.response));
    }
}
function* requestNewPassWord(action) {
    try {
        const response = yield effects_1.call(getNewPassword, { email: action.payload.email });
        if (response.data == "") {
            yield effects_1.put(actions_1.actionCreators.putForgotPasswordSuccess(true));
        }
    }
    catch (error) {
        yield effects_1.put(actions_1.actionCreators.putForgotPasswordFailed(error.response));
    }
}
exports.watchUserProfileAsync = effects_1.takeLatest(actions_1.actions.FETCH_USER_PROFILE, fetchUserProfile);
exports.watchCreateUserAsync = effects_1.takeLatest(actions_1.actions.CREATE_USER, createUser);
exports.watchRequestNewPasswordUserAsync = effects_1.takeLatest(actions_1.actions.REQUEST_NEW_PASSWORD, requestNewPassWord);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/userProfile/sagas.ts